import Column from "@/atoms-react/column/Column.react";
import { AlgoregSessionState } from "@/features/algoreg-session/types";
import { IFrameKYCAuthorizations } from "@/features/kyc/constants";
import { generateSessionURL } from "@/features/kyc/functions";
import { type KYCSessionURLParams } from "@/features/kyc/types";
import type React from "react";
import { useEffect } from "react";

type KYCSessionIFrameProps = {
  algoregSession: AlgoregSessionState;
  params?: Partial<KYCSessionURLParams>;
  onFinish: (success: boolean) => void;
} & React.ComponentPropsWithoutRef<"div">;

export const KYCIdentitySessionIFrame = ({
  algoregSession,
  params,
  onFinish,
  ...props
}: KYCSessionIFrameProps) => {
  useEffect(() => {
    window.addEventListener("message", (event) => {
      handleIFrameKYCEvent(event);
    });
    return () => {
      window.removeEventListener("message", (event) => {
        handleIFrameKYCEvent(event);
      });
    };
  }, []);

  const handleIFrameKYCEvent = async (event: {
    data: { event: string; content: { url: string; success: boolean } };
  }) => {
    if (event.data.event === "reload") {
      window.location.reload();
    }
    if (event.data.event === "end_session") {
      onFinish(event.data.content.success);
    }
  };

  return (
    <Column
      className={"m-0 h-screen w-full min-w-1 flex-1 justify-center self-center p-0"}
      {...props}
    >
      {algoregSession && (
        <iframe
          width="100%"
          height="100%"
          src={generateSessionURL(algoregSession, params).toString()}
          allow={IFrameKYCAuthorizations}
          data-cy="algoreg-iframe"
          loading="eager"
        ></iframe>
      )}
    </Column>
  );
};
